import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextProps } from 'react-native';
import theme from 'shared/styles/theme';

const TitleXLText = forwardRef<Text, TextProps>(
  ({ children, style, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        testID="title-xl"
        style={[styles.titleXLText, style]}
        {...props}
      >
        {children}
      </Text>
    );
  },
);

const styles = StyleSheet.create({
  titleXLText: {
    ...theme.typography.title.xl,
    color: theme.color.text.primary,
  },
});

export default TitleXLText;
